<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!--        <div v-if="$gate.isUser()">-->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <br />
            <div class="col-lg-12" v-if="$gate.isMISAdmin()">
                <div class="card card-danger card-outline">
                    <div class="card-header">
                        <div class="card-title">
                            Import Wizard
                            <span
                                class="badge badge-danger"
                                v-if="upload_status == 'Complete'"
                            >
                                &nbsp; Last Parsed and Loaded Items Count:
                                {{ count }} &nbsp
                            </span>
                        </div>
                        <div class="card-tools">
                            <!--                        &lt;!&ndash; Collapse Button &ndash;&gt;-->
                            <button
                                type="button"
                                class="btn btn-tool btn-danger"
                                data-card-widget="collapse"
                            >
                                <i class="fas fa-minus"></i> Show/Hide
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12 float-left">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-secondary"
                                            style="width: 100% !important"
                                            @click="getTemplate"
                                        >
                                            Get Sample Template
                                        </button>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-success"
                                            style="width: 100% !important"
                                            @click="uploadPrompt"
                                        >
                                            Import DataSheet
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <div class="col-lg-12">
                <div class="card card-danger card-outline collapsed-card">
                    <div class="card-header">
                        <div class="card-title">Data Filters</div>
                        <div class="card-tools">
                            <button
                                type="button"
                                class="btn btn-tool btn-danger"
                                data-card-widget="collapse"
                            >
                                <i class="fas fa-minus"></i> Show/Hide
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12 float-left">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Created |From Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="filters.from_date"
                                            placeholder="From date"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Created |To Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="filters.to_date"
                                            placeholder="To date"
                                        />
                                    </div>
                                </div>
                                <!--                                <div class="col-sm-4">-->
                                <!--                                    <div class="form-group">-->
                                <!--                                        <span-->
                                <!--                                            class="right badge badge-secondary"-->
                                <!--                                            >Assignment Status:</span-->
                                <!--                                        >-->
                                <!--                                        <select-->
                                <!--                                            v-model="params.assignment"-->
                                <!--                                            style="width: 100% !important"-->
                                <!--                                            class="form-control"-->
                                <!--                                        >-->
                                <!--                                            <option value="0">-->
                                <!--                                                Un-assigned-->
                                <!--                                            </option>-->
                                <!--                                            <option value="1">Assigned</option>-->
                                <!--                                            &lt;!&ndash; <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> &ndash;&gt;-->
                                <!--                                        </select>-->
                                <!--                                    </div>-->
                                <!--                                </div>-->

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Status:</span
                                        >
                                        <select
                                            v-model="filters.validity"
                                            style="width: 100% !important"
                                            class="form-control"
                                        >
                                            <option value="Active">
                                                Active
                                            </option>
                                            <option value="Inactive">
                                                Inactive
                                            </option>
                                            <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                        </select>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Incentive ID:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter a valid incentive id"
                                            v-model="filters.id"
                                            type="number"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Item Code:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter a valid item code"
                                            v-model="filters.itemcode"
                                            type="number"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Item Name:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter item name"
                                            v-model="filters.itemname"
                                            type="text"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Serial/IMEI:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter item serial/imei"
                                            v-model="filters.itemsl"
                                            type="text"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Division:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter item division"
                                            v-model="filters.itemdivision"
                                            type="text"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Category:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter item category"
                                            v-model="filters.itemcategory"
                                            type="text"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Brand:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter item brand"
                                            v-model="filters.itembrand"
                                            type="text"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Product:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter item product"
                                            v-model="filters.itemproduct"
                                            type="text"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Product:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter item product"
                                            v-model="filters.itemnotes"
                                            type="text"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Created By:</span
                                        >
                                        <v-select
                                            v-model="filters.created_by"
                                            :options="salesmen"
                                            label="user_detail"
                                            :reduce="(salesmen) => salesmen.id"
                                        ></v-select>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Results per Page:</span
                                        >
                                        <input
                                            type="number"
                                            class="form-control"
                                            v-model="filters.results"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-primary"
                                            style="width: 100% !important"
                                            @click="
                                                getAllRules(
                                                    '/api/getAllIncentiveRules'
                                                )
                                            "
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            style="width: 100% !important"
                                            @click="reset"
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br /><br />

            <div class="col-md-12">
                <div class="card card-primay card-outline">
                    <div class="card-body overflow-auto">
                        <table
                            class="table table-hover table-striped table-bordered"
                        >
                            <thead>
                                <tr>
                                    <th scope="col">ID</th>
                                    <th scope="col">ITEMCODE</th>
                                    <th scope="col">ITEM NAME</th>
                                    <th scope="col">SERIAL NUMBER</th>
                                    <th scope="col">INCENTIVE AMOUNT</th>
                                    <th scope="col">UPSELL BARRIER</th>
                                    <th scope="col">UPSELL INCENTIVE</th>
                                    <th scope="col">ALL BRANCHES</th>
                                    <th scope="col">SPECIFIC ITEM</th>
                                    <th scope="col">MULTIPARTY</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="j in data">
                                    <td
                                        @click="
                                            openValidityModal(j.id, j.validity)
                                        "
                                    >
                                        {{ j.id }}
                                        <span
                                            v-if="j.validity === 'Inactive'"
                                            class="right badge badge-danger"
                                            >{{ j.validity }}</span
                                        ><span
                                            v-if="j.validity === 'Active'"
                                            class="right badge badge-success"
                                            >{{ j.validity }}</span
                                        >
                                    </td>
                                    <td>{{ j.item_code }}</td>
                                    <td>{{ j.item_name }}</td>
                                    <td>{{ j.item_sl }}</td>
                                    <td>{{ j.amount }}</td>
                                    <td>{{ j.upsell_price }}</td>
                                    <td>{{ j.upsell_amount }}</td>
                                    <td v-if="j.all_branches == true">
                                        <i
                                            class="fa fa-check"
                                            style="color: green"
                                        ></i>
                                    </td>
                                    <td
                                        v-if="j.all_branches == false"
                                        @click="
                                            openBranchesModal(
                                                j.incentive_rule_branches
                                            )
                                        "
                                    >
                                        <i
                                            class="fa fa-times"
                                            style="color: red"
                                        ></i>
                                    </td>
                                    <td v-if="j.specific_unit == true">
                                        <i
                                            class="fa fa-check"
                                            style="color: green"
                                        ></i>
                                    </td>
                                    <td v-if="j.specific_unit == false">
                                        <i
                                            class="fa fa-times"
                                            style="color: red"
                                        ></i>
                                    </td>
                                    <td
                                        v-if="j.multi_party == true"
                                        @click="
                                            openPartiesModal(
                                                j.incentive_rule_parties
                                            )
                                        "
                                    >
                                        <i
                                            class="fa fa-check"
                                            style="color: green"
                                        ></i>
                                    </td>
                                    <td v-if="j.multi_party == false">
                                        <i
                                            class="fa fa-times"
                                            style="color: red"
                                        ></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer">
                        <pagination
                            :pagination="pagination"
                            @prev="getAllRules(pagination.prevPageUrl)"
                            @next="getAllRules(pagination.nextPageUrl)"
                        ></pagination>
                    </div>
                </div>
            </div>
            <!-- row end -->
        </section>
        <!-- /.content -->

        <div class="modal" tabindex="-1" role="dialog" id="uploadModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Incentive Rules Import Wizard
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div
                            :class="[
                                'form-group',
                                errors.link ? 'has-error' : '',
                            ]"
                        >
                            <label for="file">Excel File</label>
                            <input
                                class="form-control"
                                id="file"
                                type="file"
                                ref="file"
                                name="link"
                                placeholder="Upload Excel"
                                @change="addFile"
                            />
                            <span
                                v-if="errors.link"
                                :class="['badge bg-danger']"
                                >Please add an excel file.</span
                            >
                        </div>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary" @click="uploadFile">
                            Submit
                        </button>
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="validityModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Toggle Status</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <select
                            v-model="selectedValidity"
                            @change="saveValidityChanges"
                        >
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                        </select>
                    </div>
                    <div class="card-footer">
                        <!--                        <button class="btn btn-primary" @click="uploadFile">-->
                        <!--                            Submit-->
                        <!--                        </button>-->
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="multiBranchModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Multi-Branch Incentives</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">{{ branchIncentives }}</div>
                    <div class="card-footer">
                        <!--                        <button class="btn btn-primary" @click="uploadFile">-->
                        <!--                            Submit-->
                        <!--                        </button>-->
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="multiPartyModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Multi-Party Incentives</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">{{ partyIncentives }}</div>
                    <div class="card-footer">
                        <!--                        <button class="btn btn-primary" @click="uploadFile">-->
                        <!--                            Submit-->
                        <!--                        </button>-->
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <loading :show="lshow" :label="llabel"> </loading>
        <!-- All VUE Parts end before this comment -->
        <!--        </div>-->
        <!--        <div v-if="!$gate.isUser()">-->
        <!--             <access-denied></access-denied>-->
        <!--        </div>-->
    </div>
</template>

<script>
import Pagination from "../../pagination.vue";
import { parse } from "postcss";
import loading from "vue-full-loading";

export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { loading, pagination: Pagination },

    created() {
        this.fromdate = new Date().toISOString().slice(0, 10);
        this.todate = new Date().toISOString().slice(0, 10);
        this.params.branch = window.user.branch;
        this.getAllRules();
        this.getSalesmen();
    },

    data() {
        return {
            receipts: [],
            companies: [],
            branches: [],
            saleorders: [],
            salesmen: [],
            invoices: [],
            medias: [],
            company: "",
            branch: "",
            fromdate: "",
            todate: "",
            upload_status: "Pending",
            params: new Form({
                company: null,
                branch: null,
                campaign_media_id: null,
                is_urgent: 0,
            }),
            filters: new Form({
                validity: "",
                id: "",
                from_date: "",
                to_date: "",
                itemname: "",
                itemcode: "",
                itemdivision: "",
                itemcategory: "",
                itemproduct: "",
                itembrand: "",
                itemsl: "",
                itemnotes: "",
                results: "",
                created_by: "",
            }),
            lshow: false,
            llabel: "Syncing. Do not close or change this page...",
            file: "",
            link: "",
            status: "",
            count: "",
            lsi_id: "",
            data: null,
            selectedItemId: "",
            selectedValidity: "",
            branchIncentives: [],
            partyIncentives: [],
            errors: [],
            generated_data: [],
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
        };
    },

    methods: {
        reset() {
            this.filters.reset();
            this.getAllRules();
            this.getCompanies();
        },
        getCompanies() {
            axios.post("/api/getCompanies").then((response) => {
                this.companies = response.data;
            });
        },
        getBranches() {
            axios.post("/api/getSAPBranches").then((response) => {
                this.branches = response.data;
            });
        },

        getSalesmen() {
            axios.post("/api/getBranchCallAgents").then((response) => {
                this.salesmen = response.data;
            });
        },
        getTemplate() {
            axios({
                url: "/api/getIncentiveRulesTemplateExport",
                data: { params: this.params },
                method: "post",
                responseType: "blob",
            }).then((response) => {
                toast.fire({
                    icon: "success",
                    title: "Template Generated",
                });
                var blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(response.data, "incentive_rules_template.xlsx");
            });
        },

        openValidityModal(itemId, currentValidity) {
            this.selectedItemId = itemId;
            this.selectedValidity = currentValidity;
            // Additional logic to show/hide the modal as needed
            // You may use a library like BootstrapVue for modals
            $("#validityModal").modal("show");
        },

        openBranchesModal(branchData) {
            this.branchIncentives = branchData;
            // Additional logic to show/hide the modal as needed
            // You may use a library like BootstrapVue for modals
            $("#multiBranchModal").modal("show");
        },

        openPartiesModal(partyData) {
            this.partyIncentives = partyData;
            // Additional logic to show/hide the modal as needed
            // You may use a library like BootstrapVue for modals
            $("#multiPartyModal").modal("show");
        },

        saveValidityChanges() {
            // Add logic to update the validity in your data or make an API call
            // You can use this.selectedItemId and this.selectedValidity to get the selected item and its new validity
            // Close the modal after saving
            $("#validityModal").modal("hide");
        },

        uploadPrompt() {
            $("#uploadModal").modal("show");
        },

        generatePrompt() {
            $("#generateModal").modal("show");
        },

        addFile() {
            this.file = this.$refs.file.files[0];
            this.link = this.file;
        },

        uploadFile() {
            var formData = new FormData();
            formData.append("file", this.link);
            toast.fire({
                icon: "warning",
                title: "Wait For Syncing to be Over",
            });
            this.lshow = true;
            axios({
                method: "post",
                url: "/api/postIncentiveRulesTemplateImport",
                data: formData,
                headers: { "Content-Type": "multipart/form-data" },
            })
                .then((response) => {
                    this.data = response.data;
                    toast.fire({
                        type: "success",
                        title: "File Analyzed",
                    });
                    this.errors = [];
                    this.lshow = false;
                    this.status = response.data.Status;
                    this.count = response.data.Count;
                    this.lsi_id = response.data.Data;
                    this.upload_status = "Complete";
                    $("#uploadModal").modal("hide");
                    this.getAllRules();
                })
                .catch((error) => {
                    this.lshow = false;
                    toast.fire({
                        type: "error",
                        title: "Syncing Failed",
                    });
                    this.errors = error.response.data.errors;
                });
            this.lshow = true;
        },

        getAllRules(url = "/api/getAllIncentiveRules") {
            axios.post(url, { filters: this.filters }).then((response) => {
                this.data = response.data.data.data;
                this.configPagination(response.data.data);
            });
        },

        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },
    },
};
</script>
